import { render, staticRenderFns } from "./ProductDashboard.vue?vue&type=template&id=4754bd40&"
import script from "./ProductDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProductDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports